import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { VARIANT_BUTTON_WIDTH, VARIANT_BUTTON_HEIGHT } from '../../constants';

type Labelprops = {
  order?: number;
  selected: boolean;
};

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 8px;
  max-width: 130px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  overflow: hidden;
`;

export const Label = styled.label<Labelprops>(
  props => css`
    min-width: ${VARIANT_BUTTON_WIDTH};
    max-height: ${VARIANT_BUTTON_HEIGHT};
    cursor: pointer;
    margin-right: ${layout.spacing.xSmall};
    margin-top: ${layout.spacing.xSmall};
    transition: box-shadow 0.1s linear;
    box-shadow: 0 0 0 1px ${props.theme.colors.base200};
    border-radius: 8px;

    &:hover {
      background: ${props.theme.colors.base100};
    }

    ${media.mediumDown`
      flex: 1 0 auto;
    `}

    ${props.selected &&
      css`
        box-shadow: 0 0 0 2px ${props.theme.colors.yellove500};
        color: ${p => p.theme.text.primary};
      `};

    ${props.order &&
      css`
        order: ${props.order};
      `}
  `
);

export const Input = styled.input`
  display: none;
`;

export const Title = styled.span`
  text-transform: capitalize;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const Subtitle = styled.span(
  props => css`
    font-size: ${layout.measurements.fontSizeSmall};
    color: ${props.theme.colors.base500};
    text-overflow: ellipsis;
    overflow: hidden;
  `
);
